import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  primaryColor: "#220049",
  previewMode: false,
  homeContent: {
    logo: "",
    image: "",
    heading: "Lorem Ipsum",
    content:
      "Lorem Ipsum simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry",
  },
  socialContent: {
    heading: "Connect with us",
    socialLinks: [
      { value: "Linkedin", check: true, link: "" },
      { value: "Facebook", check: true, link: "" },
      { value: "Twitter", check: true, link: "" },
      { value: "Instagram", check: true, link: "" },
    ],
  },
  aboutContent: {
    heading: "About Section",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, nulla pariatur.",
    image: "",
  },
  visionContent: {
    heading: "Vision Section 1",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, nulla pariatur.",
      "image":"",
  },
  contactContent: {
    heading: "Get in Touch",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod",
    image: "",
  },
};
const Reducer = createSlice({
  name: "seulah",
  initialState,
  reducers: {
    SetNewColor: (state, action) => {
      const { newColor } = action.payload;
      state.primaryColor = newColor;
    },
    SetSocailContent: (state, action) => {
      const { data } = action.payload;
      state.socialContent = data;
    },
    SetAboutContent: (state, action) => {
      const { data } = action.payload;
      state.aboutContent = data;
    },
    SetVisionContent: (state, action) => {
      const { data } = action.payload;
      state.visionContent = data;
    },
    SetContactContent: (state, action) => {
      const { data } = action.payload;
      state.contactContent = data;
    },
    SetPreviewMode: (state, action) => {
      const { data } = action.payload;
      state.previewMode = data;
    },
    SetHomeContent: (state, action) => {
      const { data } = action.payload;
      state.homeContent = data;
    },
  },
});
export const {
  SetNewColor,
  SetSocailContent,
  SetAboutContent,
  SetVisionContent,
  SetContactContent,
  SetPreviewMode,
  SetHomeContent,
} = Reducer.actions;

export default Reducer.reducer;
